import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import api from "../../utils/api";
import "./navbar.css";
import logo from "../img/logo.png";
import { FiUser, FiLogOut, FiChevronDown, FiMenu, FiX } from "react-icons/fi";
import Modal from "../modal/Modal";
import Perfil from "../../pages/Perfil/Perfil";
import Bell from "./Bell";
/* context */
import { Context } from "../../context/UserContext";
import useMyPermission from "../../hooks/useMyPermission";

function Navbar() {
  const { authenticated, logout, userName } = useContext(Context);
  const location = useLocation();
  const navigate = useNavigate();
  const [modalPerfil, setModalPerfil] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openMobileGroup, setOpenMobileGroup] = useState(null);

  /* ---------------------- Permission ------------------------- */
  const [myPermission, setMyPermission] = useState({ group: "", })
  const { checkPermission } = useMyPermission()

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate('/login')
    } else {

      api.get('/user/get/permission', {
        headers: {
          Authorization: `Bearer ${JSON.parse(token)}`
        }
      }).then((response) => {
        if (response) {
          setMyPermission(response.data.permission)
        }


      })
    }
  }, [authenticated]);

  const client_view = checkPermission(myPermission, "client_view")
  const myClient_view = checkPermission(myPermission, "myClient_view")
  const provider_view = checkPermission(myPermission, "provider_view")
  const cloth_view = checkPermission(myPermission, "cloth_view")
  const aviamento_view = checkPermission(myPermission, "aviamento_view")
  const category_view = checkPermission(myPermission, "category_view")
  const sizeGrid_view = checkPermission(myPermission, "sizeGrid_view")
  const commission_view = checkPermission(myPermission, "commission_view")
  const product_view = checkPermission(myPermission, "product_view")
  const simpleProduct_view = checkPermission(myPermission, "simpleProduct_view")
  const color_view = checkPermission(myPermission, "color_view")
  const colorType_view = checkPermission(myPermission, "colorType_view")
  const additive_view = checkPermission(myPermission, "additive_view")
  const accessory_view = checkPermission(myPermission, "accessory_view")
  const budget_view = checkPermission(myPermission, "budget_view")
  const myBudget_view = checkPermission(myPermission, "myBudget_view")
  const order_view = checkPermission(myPermission, "order_view")
  const myOrder_view = checkPermission(myPermission, "myOrder_view")
  const stock_view = checkPermission(myPermission, "stock_view")
  const stockGeneral_view = checkPermission(myPermission, "stockGeneral_view")
  const purchase_view = checkPermission(myPermission, "purchase_view")
  const production_view = checkPermission(myPermission, "production_view")
  const finance_view = checkPermission(myPermission, "finance_view")
  const fiscal_view = checkPermission(myPermission, "fiscal_view")
  const backup_create = checkPermission(myPermission, "backup_create")
  const historic_view = checkPermission(myPermission, "historic_view")
  const isAdminGroup = myPermission.group === "DEV_MASTER" || myPermission.group === "ADM_USER"

  const showInicioMenu = client_view || myClient_view || provider_view || cloth_view || aviamento_view || category_view || sizeGrid_view || commission_view || product_view || simpleProduct_view || color_view || colorType_view || additive_view || accessory_view
  const showComercialMenu = product_view || color_view || accessory_view || budget_view || myBudget_view || order_view || myOrder_view
  const showStockMenu = stock_view || stockGeneral_view
  const showProductionMenu = production_view || purchase_view
  const showFinanceMenu = finance_view
  const showFiscalMenu = fiscal_view
  const showAdminMenu = isAdminGroup || backup_create || historic_view

  const isInicioActive = ['/client', '/myclient', '/provider', '/cloth', '/aviamento', '/category', '/sizegrid', '/commission', '/simpleProduct', '/colortype', '/additive'].some((p) => location.pathname.startsWith(p))
  const isComercialActive = ['/product', '/color', '/accessory', '/budget', '/mybudget', '/order', '/myorder'].some((p) => location.pathname.startsWith(p))
  const isStockActive = ['/stock'].some((p) => location.pathname.startsWith(p))
  const isProductionActive = ['/production', '/purchase'].some((p) => location.pathname.startsWith(p))
  const isFinanceActive = ['/finance'].some((p) => location.pathname.startsWith(p))
  const isFiscalActive = ['/fiscal'].some((p) => location.pathname.startsWith(p))
  const isAdminActive = ['/system-user', '/backup', '/historic'].some((p) => location.pathname.startsWith(p))

  const userFirstName = (userName || '').split(' ')[0]

  // Mesma estrutura/permissões dos dropdowns abaixo, só que em formato de dados —
  // usada exclusivamente pelo painel mobile (accordion), que precisa de uma lista
  // pra iterar em vez do JSX hover-dropdown escrito à mão pro desktop.
  const menuGroups = [
    {
      key: 'inicio', show: showInicioMenu, label: 'Início', active: isInicioActive,
      items: [
        client_view && { to: '/client', label: 'Clientes' },
        myClient_view && { to: '/myclient', label: 'Meus Clientes' },
        provider_view && { to: '/provider', label: 'Fornecedores' },
        cloth_view && { to: '/cloth', label: 'Tecidos' },
        aviamento_view && { to: '/aviamento', label: 'Aviamentos' },
        category_view && { to: '/category', label: 'Categoria' },
        sizeGrid_view && { to: '/sizegrid', label: 'Grade de tamanhos' },
        commission_view && { to: '/commission', label: 'Comissão e desconto' },
        product_view && { to: '/product', label: 'Produtos' },
        simpleProduct_view && { to: '/simpleProduct', label: 'Produtos simples' },
        color_view && { to: '/color', label: 'Catálogo de Cores', end: true },
        colorType_view && { to: '/colortype', label: 'Tipos de Cores' },
        additive_view && { to: '/additive', label: 'Aditivos' },
        accessory_view && { to: '/accessory', label: 'Acessórios' },
      ].filter(Boolean),
    },
    {
      key: 'comercial', show: showComercialMenu, label: 'Comercial', active: isComercialActive,
      items: [
        product_view && { to: '/product', label: 'Produtos' },
        color_view && { to: '/color', label: 'Catálogo de Cores', end: true },
        accessory_view && { to: '/accessory', label: 'Acessórios' },
        budget_view && { to: '/budget', label: 'Orçamentos', end: true },
        myBudget_view && { to: '/mybudget', label: 'Meus Orçamentos' },
        order_view && { to: '/order', label: 'Pedidos', end: true },
        myOrder_view && { to: '/myorder', label: 'Meus Pedidos' },
      ].filter(Boolean),
    },
    {
      key: 'estoque', show: showStockMenu, label: 'Estoque', active: isStockActive,
      items: [
        stock_view && { to: '/stock', label: 'Matéria-Prima', end: true },
        stockGeneral_view && { to: '/stock/general', label: 'Geral' },
      ].filter(Boolean),
    },
    {
      key: 'producao', show: showProductionMenu, label: 'Produção', active: isProductionActive,
      items: [
        purchase_view && { to: '/purchase', label: 'Compras' },
        production_view && { to: '/production', label: 'Acompanhamento', end: true },
        production_view && { to: '/production/cut', label: 'Corte' },
        production_view && { to: '/production/sewing', label: 'Costura' },
        production_view && { to: '/production/finishing', label: 'Acabamento' },
        production_view && { to: '/production/inspection', label: 'Inspeção' },
        production_view && { to: '/production/shipping', label: 'Expedição' },
        production_view && { to: '/production/external-faction', label: 'Facção Externa' },
      ].filter(Boolean),
    },
    {
      key: 'financeiro', show: showFinanceMenu, label: 'Financeiro', active: isFinanceActive,
      items: [
        finance_view && { to: '/finance/payable', label: 'Contas a Pagar' },
        finance_view && { to: '/finance/receivable', label: 'Contas a Receber' },
        finance_view && { to: '/finance/recurring', label: 'Contas Fixas' },
        finance_view && { to: '/finance/categories', label: 'Categorias' },
        finance_view && { to: '/finance/cashflow', label: 'Fluxo de Caixa' },
        finance_view && { to: '/finance/report', label: 'Relatório' },
      ].filter(Boolean),
    },
    {
      key: 'fiscal', show: showFiscalMenu, label: 'Fiscal', active: isFiscalActive,
      items: [
        fiscal_view && { to: '/fiscal', label: 'Notas Fiscais', end: true },
        fiscal_view && { to: '/fiscal/config', label: 'Perfil da Empresa' },
      ].filter(Boolean),
    },
    {
      key: 'admin', show: showAdminMenu, label: 'Administrador', active: isAdminActive,
      items: [
        isAdminGroup && { to: '/system-user/list', label: 'Usuários' },
        backup_create && { to: '/backup', label: 'Backup' },
        historic_view && { to: '/historic/list', label: 'Histórico' },
      ].filter(Boolean),
    },
  ]

  useEffect(() => {
    setMobileOpen(false)
    setOpenMobileGroup(null)
  }, [location.pathname])

  if (authenticated) {
    return (
      <>
      <nav className="navbar">
        <div className="navbar-left-side">
          <div className="navbar-logo">
            <img className="navbar-logo-img" src={logo} alt="logo" />
          </div>

          <div className="navbar-options">
            {showInicioMenu &&
              <div className="dropdown">
                <li className={`dropbtn${isInicioActive ? ' dropbtn-active' : ''}`}>
                  Início <FiChevronDown size={12} className="dropbtn-chevron" />
                </li>
                <div className="dropdown-content">
                  {client_view && <NavLink className='navbar-option-item' to="/client">Clientes</NavLink>}
                  {myClient_view && <NavLink className='navbar-option-item' to="/myclient">Meus Clientes</NavLink>}
                  {provider_view && <NavLink className='navbar-option-item' to="/provider">Fornecedores</NavLink>}
                  {cloth_view && <NavLink className='navbar-option-item' to="/cloth">Tecidos</NavLink>}
                  {aviamento_view && <NavLink className='navbar-option-item' to="/aviamento">Aviamentos</NavLink>}
                  {category_view && <NavLink className='navbar-option-item' to="/category">Categoria</NavLink>}
                  {sizeGrid_view && <NavLink className='navbar-option-item' to="/sizegrid">Grade de tamanhos</NavLink>}
                  {commission_view && <NavLink className='navbar-option-item' to="/commission">Comissão e desconto</NavLink>}
                  {product_view && <NavLink className='navbar-option-item' to="/product">Produtos</NavLink>}
                  {simpleProduct_view && <NavLink className='navbar-option-item' to="/simpleProduct">Produtos simples</NavLink>}
                  {color_view && <NavLink end className='navbar-option-item' to="/color">Catálogo de Cores</NavLink>}
                  {colorType_view && <NavLink className='navbar-option-item' to="/colortype">Tipos de Cores</NavLink>}
                  {additive_view && <NavLink className='navbar-option-item' to="/additive">Aditivos</NavLink>}
                  {accessory_view && <NavLink className='navbar-option-item' to="/accessory">Acessórios</NavLink>}
                </div>
              </div>
            }

            {showComercialMenu &&
              <div className="dropdown">
                <li className={`dropbtn${isComercialActive ? ' dropbtn-active' : ''}`}>
                  Comercial <FiChevronDown size={12} className="dropbtn-chevron" />
                </li>
                <div className="dropdown-content">
                  {product_view && <NavLink className='navbar-option-item' to="/product">Produtos</NavLink>}
                  {color_view && <NavLink end className='navbar-option-item' to="/color">Catálogo de Cores</NavLink>}
                  {accessory_view && <NavLink className='navbar-option-item' to="/accessory">Acessórios</NavLink>}
                  {budget_view && <NavLink end className='navbar-option-item' to="/budget">Orçamentos</NavLink>}
                  {myBudget_view && <NavLink className='navbar-option-item' to="/mybudget">Meus Orçamentos</NavLink>}
                  {order_view && <NavLink end className='navbar-option-item' to="/order">Pedidos</NavLink>}
                  {myOrder_view && <NavLink className='navbar-option-item' to="/myorder">Meus Pedidos</NavLink>}
                </div>
              </div>
            }

            {showStockMenu &&
              <div className="dropdown">
                <li className={`dropbtn${isStockActive ? ' dropbtn-active' : ''}`}>
                  Estoque <FiChevronDown size={12} className="dropbtn-chevron" />
                </li>
                <div className="dropdown-content">
                  {stock_view && <NavLink end className='navbar-option-item' to="/stock">Matéria-Prima</NavLink>}
                  {stockGeneral_view && <NavLink className='navbar-option-item' to="/stock/general">Geral</NavLink>}
                </div>
              </div>
            }

            {showProductionMenu &&
              <div className="dropdown">
                <li className={`dropbtn${isProductionActive ? ' dropbtn-active' : ''}`}>
                  Produção <FiChevronDown size={12} className="dropbtn-chevron" />
                </li>
                <div className="dropdown-content">
                  {purchase_view && <NavLink className='navbar-option-item' to="/purchase">Compras</NavLink>}
                  {production_view && <NavLink end className='navbar-option-item' to="/production">Acompanhamento</NavLink>}
                  {production_view && <NavLink className='navbar-option-item' to="/production/cut">Corte</NavLink>}
                  {production_view && <NavLink className='navbar-option-item' to="/production/sewing">Costura</NavLink>}
                  {production_view && <NavLink className='navbar-option-item' to="/production/finishing">Acabamento</NavLink>}
                  {production_view && <NavLink className='navbar-option-item' to="/production/inspection">Inspeção</NavLink>}
                  {production_view && <NavLink className='navbar-option-item' to="/production/shipping">Expedição</NavLink>}
                  {production_view && <NavLink className='navbar-option-item' to="/production/external-faction">Facção Externa</NavLink>}
                </div>
              </div>
            }

            {showFinanceMenu &&
              <div className="dropdown">
                <li className={`dropbtn${isFinanceActive ? ' dropbtn-active' : ''}`}>
                  Financeiro <FiChevronDown size={12} className="dropbtn-chevron" />
                </li>
                <div className="dropdown-content">
                  {finance_view && <NavLink className='navbar-option-item' to="/finance/payable">Contas a Pagar</NavLink>}
                  {finance_view && <NavLink className='navbar-option-item' to="/finance/receivable">Contas a Receber</NavLink>}
                  {finance_view && <NavLink className='navbar-option-item' to="/finance/recurring">Contas Fixas</NavLink>}
                  {finance_view && <NavLink className='navbar-option-item' to="/finance/categories">Categorias</NavLink>}
                  {finance_view && <NavLink className='navbar-option-item' to="/finance/cashflow">Fluxo de Caixa</NavLink>}
                  {finance_view && <NavLink className='navbar-option-item' to="/finance/report">Relatório</NavLink>}
                </div>
              </div>
            }

            {showFiscalMenu &&
              <div className="dropdown">
                <li className={`dropbtn${isFiscalActive ? ' dropbtn-active' : ''}`}>
                  Fiscal <FiChevronDown size={12} className="dropbtn-chevron" />
                </li>
                <div className="dropdown-content">
                  {fiscal_view && <NavLink end className='navbar-option-item' to="/fiscal">Notas Fiscais</NavLink>}
                  {fiscal_view && <NavLink className='navbar-option-item' to="/fiscal/config">Perfil da Empresa</NavLink>}
                </div>
              </div>
            }

            {showAdminMenu &&
              <div className="dropdown">
                <li className={`dropbtn${isAdminActive ? ' dropbtn-active' : ''}`}>
                  Administrador <FiChevronDown size={12} className="dropbtn-chevron" />
                </li>
                <div className="dropdown-content">
                  {isAdminGroup && <NavLink className='navbar-option-item' to="/system-user/list">Usuários</NavLink>}
                  {backup_create && <NavLink className='navbar-option-item' to="/backup">Backup</NavLink>}
                  {historic_view && <NavLink className='navbar-option-item' to="/historic/list">Histórico</NavLink>}
                </div>
              </div>
            }
          </div>
        </div>

        <div className="navbar-right-side">
          <button type="button" className="navbar-hamburger-btn" onClick={() => setMobileOpen(true)} aria-label="Abrir menu">
            <FiMenu size={22} />
          </button>
          <Bell />
          <div className="navbar-user-area" onClick={() => setModalPerfil(true)}>
            <FiUser size={15} className="navbar-user-icon" />
            <span className="navbar-user-name">{userFirstName}</span>
          </div>
          <div className="navbar-logout" onClick={logout}>
            <FiLogOut size={15} /><span>Sair</span>
          </div>
        </div>
      </nav>

      {mobileOpen &&
        <div className="navbar-mobile-backdrop" onClick={() => setMobileOpen(false)}>
          <div className="navbar-mobile-panel" onClick={(e) => e.stopPropagation()}>
            <div className="navbar-mobile-panel-header">
              <img className="navbar-mobile-logo" src={logo} alt="logo" />
              <button type="button" className="navbar-mobile-close" onClick={() => setMobileOpen(false)} aria-label="Fechar menu">
                <FiX size={20} />
              </button>
            </div>

            <div className="navbar-mobile-groups">
              {menuGroups.filter((group) => group.show).map((group) => (
                <div key={group.key} className="navbar-mobile-group">
                  <button
                    type="button"
                    className={`navbar-mobile-group-btn${group.active ? ' navbar-mobile-group-btn-active' : ''}`}
                    onClick={() => setOpenMobileGroup(openMobileGroup === group.key ? null : group.key)}
                  >
                    <span>{group.label}</span>
                    <FiChevronDown size={14} className={`dropbtn-chevron${openMobileGroup === group.key ? ' navbar-mobile-chevron-open' : ''}`} />
                  </button>
                  {openMobileGroup === group.key &&
                    <div className="navbar-mobile-group-items">
                      {group.items.map((item) => (
                        <NavLink key={item.to} end={item.end} className="navbar-mobile-item" to={item.to}>
                          {item.label}
                        </NavLink>
                      ))}
                    </div>
                  }
                </div>
              ))}
            </div>

            <div className="navbar-mobile-panel-footer">
              <div className="navbar-user-area" onClick={() => { setMobileOpen(false); setModalPerfil(true) }}>
                <FiUser size={15} className="navbar-user-icon" />
                <span className="navbar-user-name">{userFirstName}</span>
              </div>
              <div className="navbar-logout" onClick={logout}>
                <FiLogOut size={15} /><span>Sair</span>
              </div>
            </div>
          </div>
        </div>
      }

      <Modal
        modalStatus={modalPerfil}
        changeStatus={setModalPerfil}
        w={40}
        h={62}
        content={
          <Perfil btCancelAction={() => setModalPerfil(false)} />
        }
      />
      </>
    );
  } else {
    return <div></div>;
  }
}

export default Navbar;
